export const URL_ROOT = "root-url";

export const URL_ACCOUNT_LOGIN = "account-login";
export const URL_ACCOUNT_CREATE = "account-create";
export const URL_ACCOUNT_CONFIRM = "confirm-user-url";
export const URL_ACCOUNT_FORGOT_PASSWORD = "forgot-password-url";
export const URL_ACCOUNT_RESET_PASSWORD = "reset-password-url";
export const URL_ACCOUNT_CONFIRM_EMAIL_CHANGE = "confirm-email-change-url";
export const URL_ACCOUNT_SETTINGS = "user-settings-url";
export const URL_ACCOUNT_ADMIN_CONFIRM = "confirm-admin-url";
export const URL_ACCOUNT_PROJECT_MANAGER_CONFIRM = "confirm-project-manager-url";
export const URL_ACCOUNT_MERCHANT_CONFIRM = "confirm-merchant-url";
export const URL_ACCOUNT_ORGANIZATION_MANAGER_CONFIRM = "confirm-organization-manager-url";
export const URL_ACCOUNT_MARKET_GROUP_MANAGER_CONFIRM = "confirm-market-group-manager-url";
export const URL_ACCOUNT_UNSUBSCRIBE_EMAIL = "unsubscribe-email-url";

export const URL_PROFILE_EDIT = "edit-profile-url";

export const URL_ADMIN_USERS = "admin-users-url";
export const URL_ADMIN_USER_PROFILE = "admin-user-profile-url";
export const URL_ADMIN_ADD_USER = "admin-add-user-url";
export const URL_ADMIN_DELETE_USER = "admin-delete-user-url";
export const URL_ADMIN_DISABLE_USER = "admin-disable-user-url";
export const URL_ADMIN_REACTIVATE_USER = "admin-reactivate-user-url";

export const URL_DOC_FORM = "form-example-url";
export const URL_DOC_CALENDAR = "calendar-url";
export const URL_DOC_BTN_GROUP = "btn-group-url";
export const URL_DOC_DIALOG = "dialog-url";
export const URL_DOC_DIALOG_BASIC = "dialog-basic-url";
export const URL_DOC_DIALOG_CONFIRM = "dialog-confirm-url";
export const URL_DOC_DIALOG_DELETE = "dialog-delete-url";

export const URL_PROJECT_ADMIN = "project-list-url";
export const URL_PROJECT_ADD = "project-add-url";
export const URL_PROJECT_EDIT = "project-edit-url";
export const URL_PROJECT_DELETE = "project-delete-url";
export const URL_PROJECT_MANAGE_MERCHANTS = "project-manage-merchants-url";
export const URL_PROJECT_MANAGE_MANAGERS = "project-manage-managers-url";
export const URL_PROJECT_MANAGER_REMOVE = "project-manage-managers-remove-url";
export const URL_REMOVE_MERCHANTS_FROM_PROJECT = "project-remove-market";
export const URL_PROJECT_ADMIN_DASHBOARD = "project-admin-dashboard-url";
export const URL_ADD_MERCHANTS_FROM_PROJECT = "project-add-market";

export const URL_MARKET_ADMIN = "market-list-url";
export const URL_MARKET_ADD = "market-add-url";
export const URL_MARKET_DELETE = "market-delete-url";
export const URL_MARKET_MANAGE_MANAGERS = "market-manage-managers-url";
export const URL_MARKET_EDIT = "market-edit-url";
export const URL_MARKET_ARCHIVE = "market-archive-url";
export const URL_MARKET_DISABLED = "market-disabled-url";
export const URL_MARKET_ENABLED = "market-enabled-url";
export const URL_MARKET_TRANSACTION_REFUND = "market-transaction-refund-url";

export const URL_MARKET_OVERVIEW = "market-overview-url";
export const URL_MARKET_OVERVIEW_SELECT = "market-overview-select-url";
export const URL_MARKET_OVERVIEW_ADD = "market-overview-add-url";
export const URL_MARKET_OVERVIEW_DELETE = "market-overview-delete-url";
export const URL_MARKET_OVERVIEW_MANAGE_MANAGERS = "market-overview-manage-managers-url";
export const URL_MARKET_OVERVIEW_EDIT = "market-overview-edit-url";
export const URL_MARKET_OVERVIEW_ARCHIVE = "market-overview-archive-url";
export const URL_MARKET_OVERVIEW_ENABLED = "market-overview-enabled-url";
export const URL_MARKET_OVERVIEW_DISABLED = "market-overview-disabled-url";

export const URL_MARKET_GROUPS_OVERVIEW = "market-groups-overview-url";
export const URL_MARKET_GROUP_ADD = "market-group-add-url";
export const URL_MARKET_GROUP_EDIT = "market-group-edit-url";
export const URL_MARKET_GROUP_DELETE = "market-group-delete-url";
export const URL_MARKET_GROUP_ARCHIVE = "market-group-archive-url";
export const URL_MARKET_GROUP_MANAGE_MANAGERS = "market-group-manage-managers-url";
export const URL_MARKET_GROUP_MANAGE_MERCHANTS = "market-group-manage-merchants-url";
export const URL_REMOVE_MERCHANTS_FROM_MARKET_GROUP = "market-group-remove-market-url";
export const URL_ADD_MERCHANTS_FROM_MARKET_GROUP = "market-group-add-market-url";
export const URL_MARKETGROUP_TRANSACTION_LIST = "market-group-transaction-list-url";
export const URL_MARKETGROUP_TRANSACTION_ADD = "market-group-transaction-add-url";
export const URL_MARKETGROUP_TRANSACTION_REFUND = "market-group-transaction-refund-url";
export const URL_MARKETGROUP_MANAGER_ADMIN = "marketgroup-manager-list-url";

export const URL_ORGANIZATION_ADMIN = "organization-list-url";
export const URL_ORGANIZATION_ADD = "organization-add-url";
export const URL_ORGANIZATION_DELETE = "organization-delete-url";
export const URL_ORGANIZATION_MANAGE_MANAGERS = "organization-manage-managers-url";
export const URL_ORGANIZATION_MANAGER_REMOVE = "organization-manage-managers-remove-url";
export const URL_ORGANIZATION_EDIT = "organization-edit-url";
export const URL_ORGANIZATION_MANAGE_MERCHANTS = "organization-manage-merchants-url";
export const URL_REMOVE_MERCHANTS_FROM_ORGANIZATION = "organization-remove-market-url";

export const URL_SUBSCRIPTION_ADMIN = "subscription-list-url";
export const URL_SUBSCRIPTION_ADD = "subscription-add-url";
export const URL_SUBSCRIPTION_EDIT = "subscription-edit-url";
export const URL_SUBSCRIPTION_DELETE = "subscription-delete-url";
export const URL_SUBSCRIPTION_ARCHIVE = "subscription-archive-url";
export const URL_SUBSCRIPTION_UNARCHIVE = "subscription-unarchive-url";
export const URL_SUBSCRIPTION_MANAGE_BUDGET_ALLOWANCE = "subscription-manage-budget-allowance-url";
export const URL_SUBSCRIPTION_DELETE_BUDGET_ALLOWANCE = "subscription-delete-budget-allowance-url";
export const URL_SUBSCRIPTION_MOVE_BUDGET_ALLOWANCE = "subscription-move-budget-allowance-url";

export const URL_BENEFICIARY_ADMIN = "beneficiary-list-url";
export const URL_BENEFICIARY_ADD = "beneficiary-add-url";
export const URL_BENEFICIARY_MANAGE_SUBSCRIPTIONS = "beneficiary-manage-subscriptions-url";
export const URL_BENEFICIARY_REMOVE_SUBSCRIPTION = "beneficiary-remove-subscription-url";
export const URL_BENEFICIARY_EDIT = "beneficiary-edit-url";
export const URL_BENEFICIARY_DELETE = "beneficiary-delete-url";
export const URL_BENEFICIARY_IMPORT_LIST = "beneficiary-import-list-url";
export const URL_BENEFICIARY_ASSIGN_SUBSCRIPTIONS = "beneficiary-assign-subscriptions";
export const URL_BENEFICIARY_MANUALLY_ADD_FUND = "beneficiary-manually-add-fund";
export const URL_BENEFICIARY_OFF_PLATFORM_IMPORT_LIST = "beneficiary-off-platform-import-list-url";
export const URL_BENEFICIARY_QRCODE_PREVIEW = "beneficiary-qrcode-preview-url";
export const URL_BENEFICIARY_CARD_LOST = "beneficiary-card-lost-url";
export const URL_BENEFICIARY_CARD_UNASSIGN = "beneficiary-card-unassign-url";
export const URL_BENEFICIARY_CARD_ASSIGN = "beneficiary-card-assign-url";
export const URL_BENEFICIARY_CARD_DISABLE = "beneficiary-card-disable-url";
export const URL_BENEFICIARY_CARD_ENABLE = "beneficiary-card-enable-url";
export const URL_BENEFICIARY_MANAGE = "beneficiary-manage-url";
export const URL_BENEFICIARY_MANAGE_CONFLICT = "beneficiary-manage-conflict-url";
export const URL_BENEFICIARY_ADD_MISSED_PAYMENT = "beneficiary-add-missed-payment-url";
export const URL_BENEFICIARY_TRANSACTION_ADD = "beneficiary-transaction-add-url";
export const URL_BENEFICIARY_ADMIN_AVAILABLE_AMOUNT_FOR_ALLOCATION = "beneficiary-admin-available-amount-for-allocation-url";
export const URL_BENEFICIARY_TRANSFER_FUNDS = "beneficiary-transfer-funds-url";
export const URL_BENEFICIARY_EDIT_GIFT_CARD = "beneficiary-edit-gift-card-url";
export const URL_BENEFICIARY_CHANGE_MAX_NUMBER_OF_PAYMENTS = "beneficiary-change-max-number-of-payments-url";

export const URL_PROJECT_MANAGER_ADMIN = "project-manager-list-url";
export const URL_PROJECT_MANAGER_ADD = "project-manager-add-url";
export const URL_PROJECT_SETTINGS = "project-settings-url";
export const URL_RECONCILIATION_REPORT = "reconciliation-report-url";
export const URL_SUBSCRIPTION_END_REPORT = "subscription-end-report-url";
export const URL_BUDGET_ALLOWANCE_REPORT = "budget-allowance-report-url";

export const URL_ORGANIZATION_MANAGER_ADMIN = "organization-manager-list-url";
export const URL_ORGANIZATION_MANAGER_ADD = "organization-manager-add-url";

export const URL_CASH_REGISTER = "cash-register-url";
export const URL_CASH_REGISTER_ADD = "cash-register-add-url";
export const URL_CASH_REGISTER_EDIT = "cash-register-edit-url";
export const URL_CASH_REGISTER_ARCHIVE = "cash-register-archive-url";
export const URL_CASH_REGISTER_ADD_MARKET_GROUP = "cash-register-add-market-group-url";

export const URL_CARDS = "cards-list-url";
export const URL_CARDS_ADD = "cards-add-url";
export const URL_CARDS_LOST = "cards-lost-url";
export const URL_CARDS_QRCODE_PREVIEW = "cards-qrcode-preview-url";
export const URL_CARDS_UNASSIGN = "cards-unassign-url";
export const URL_CARDS_GIFT_CARD_ADD = "cards-gift-card-add-url";
export const URL_CARDS_GIFT_CARD_LOST = "cards-gift-card-lost-url";
export const URL_GIFT_CARD_ADD = "cards-gift-card-add-url";
export const URL_GIFT_CARD_EDIT = "cards-gift-card-edit-url";
export const URL_CARDS_BRANDING = "cards-branding-url";
export const URL_CARDS_ENABLE = "cards-enable-url";
export const URL_CARDS_DISABLE = "cards-disable-url";
export const URL_CARDS_UNLOCK = "cards-unlock-url";
export const URL_CARDS_MANAGE = "cards-manage-url";
export const URL_CARDS_MANAGE_GIFT_CARDS = "cards-manage-gift-cards-url";
export const URL_CARD_TRANSACTION_ADD = "card-transaction-add-url";
export const URL_CARDS_GIFT_CARD_DISABLE = "cards-gift-card-disable-url";
export const URL_CARDS_GIFT_CARD_ENABLE = "cards-gift-card-enable-url";
export const URL_CARDS_GIFT_CARD_QRCODE_PREVIEW = "cards-gift-card-qrcode-preview-url";

export const URL_CARD_CHECK = "card-check-url";
export const URL_CARD_ERROR = "card-error-url";
export const URL_UNSUBSCRIBE_TRANSACTION_RECEIPT = "unsubscribe-transaction-receipt-url";

export const URL_TRANSACTION = "transaction-url";
export const URL_TRANSACTION_ERROR = "transaction-error-url";
export const URL_TRANSACTION_LIST = "market-transaction-list-url";
export const URL_TRANSACTION_ADMIN = "transaction-list-url";
export const URL_TRANSACTION_ADD = "transaction-add-url";
export const URL_TRANSACTION_ADMIN_REFUND = "transaction-admin-refund-url";

export const URL_CATEGORY_ADMIN = "category-list-url";
export const URL_CATEGORY_ADD = "category-add-url";
export const URL_CATEGORY_EDIT = "category-edit-url";
export const URL_CATEGORY_DELETE = "category-delete-url";

export const URL_PRODUCT_GROUP_ADMIN = "productgroup-list-url";
export const URL_PRODUCT_GROUP_ADD = "productgroup-add-url";
export const URL_PRODUCT_GROUP_EDIT = "productgroup-edit-url";
export const URL_PRODUCT_GROUP_DELETE = "productgroup-delete-url";
